// CRA injects REACT_APP_* at build time. Without REACT_APP_API_URL, axios uses the
// dev-server origin (e.g. :3000) and /login never hits Django — set .env or use default.
const devApiFallback =
  process.env.NODE_ENV === 'development' ? 'http://127.0.0.1:8000' : '';

export const env = {
  apiURL: process.env.REACT_APP_API_URL || devApiFallback,
};
